
        import * as module0 from './controllers/game_collection_controller.js';import * as module1 from './controllers/photoswipe_controller.js';import * as module2 from './controllers/tooltip_controller.js'
        const modules = {
            "./controllers/game_collection_controller.js": module0,
            "./controllers/photoswipe_controller.js": module1,
            "./controllers/tooltip_controller.js": module2,
        };
        export default modules;
      